import React, { useEffect, useReducer } from 'react';
import { Switch } from 'react-router-dom';
import axios from 'axios';

import Home from '../home/Home';

import StartApplicationPage from '../start-application/StartApplicationPage';
import StartApplicationPageDebug from '../start-application/StartApplicationPageDebug';
import FinsishApplicationPage from '../finish-application/FinishApplicationPage';
import ViewQuotesPage from '../view-quotes/ViewQuotesPage';
import ViewPoliciesPage from '../view-policies/ViewPoliciesPage';
import ViewClientsPage from '../view-clients/ViewClientsPage';
import ReferenceToolsPage from '../reference-tools/ReferenceToolsPage';
import ContactUsPage from '../contact-us/ContactUsPage';
import ManageUsersPage from '../manage-users/ManageUsersPage';
import PrivateRoute from '../common/PrivateRoute';
import CoverageGuidePage from '../coverage-guide/CoverageGuidePage';
import FAQPage from '../faq/FAQPage';
import TrainingGuidesPage from '../training-guides/TrainingGuidesPage';
import ClientDetailsPage from '../client-details/ClientDetailsPage';
import DocumentsPage from '../documents/DocumentsPage';
import EndorsementsPage from '../endorsements/EndorsementsPage';
import EndorsementDetailsPage from '../endorsements/EndorsementDetailsPage';
import RequestPage from '../request/RequestPage';
import AlertDispatch from '../../contexts/alert.dispatch';
import alertReducer from '../../reducers/alert.reducer';
import userReducer from '../../reducers/user.reducer';
import UserDispatch from '../../contexts/userDispatch';
import userActions from '../../actions/user.actions';
import EditUserForm from '../manage-users/EditUserForm';
import AddUserForm from '../manage-users/AddUserForm';

import Alert from './Alert';
import Footer from './Footer';
import PrivateHeader from './PrivateHeader';
import LeftSideNav from './LeftSideNav';
import style from './PrivateLayout.module.css';

const PrivateLayout = React.memo(() => {
  const [alertState, dispatch] = useReducer(alertReducer, {
    successMessage: '',
    errorMessage: '',
  });

  const [userState, userDispatch] = useReducer(userReducer, {
    agencyName: '',
    agencyUserEmail: '',
    isAdmin: false,
  });

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BASE_URL}users`).then(data => {
      userDispatch({ type: userActions.SET_USER_NAME, data: data.data });
      window.agentEmail = data.data.agencyUserEmail;
      window.agencyName = data.data.agencyName;
      window.brandCode = 'HUB';
    });
  }, []);

  return (
    <>
      <UserDispatch.Provider value={userState}>
        <PrivateHeader />
        <LeftSideNav />
      </UserDispatch.Provider>
      <AlertDispatch.Provider value={dispatch}>
        <div className={style.main} id="top">
          <Alert
            sucessMessage={alertState.successMessage}
            errorMessage={alertState.errorMessage}
          />
          <section className={style.mainContent}>
            <Switch>
              <PrivateRoute path="/" exact component={Home} />
              <PrivateRoute
                path="/start/:clientId?"
                exact
                component={StartApplicationPage}
              />
              <PrivateRoute
                path="/start-debug/:clientId?"
                exact
                component={StartApplicationPageDebug}
              />
              <PrivateRoute
                path="/finish"
                exact
                component={FinsishApplicationPage}
              />
              <PrivateRoute path="/quotes" exact component={ViewQuotesPage} />
              <PrivateRoute
                path="/policies"
                exact
                component={ViewPoliciesPage}
              />
              <PrivateRoute path="/clients" exact component={ViewClientsPage} />
              <PrivateRoute
                path="/tools"
                exact
                component={ReferenceToolsPage}
              />
              <PrivateRoute
                path="/contact-us"
                exact
                component={ContactUsPage}
              />
              <PrivateRoute path="/users" exact component={ManageUsersPage} />
              <PrivateRoute path="/users/add" exact component={AddUserForm} />
              <PrivateRoute
                path="/agencies/:agencyId/users/:userId"
                exact
                component={EditUserForm}
              />
              <PrivateRoute
                path="/coverage-guides"
                exact
                component={CoverageGuidePage}
              />
              <PrivateRoute path="/faq" exact component={FAQPage} />
              <PrivateRoute
                path="/training-guides"
                exact
                component={TrainingGuidesPage}
              />
              <PrivateRoute
                path="/clients/:clientId"
                exact
                component={ClientDetailsPage}
              />
              <PrivateRoute
                path="/clients/:clientId/documents"
                exact
                component={DocumentsPage}
              />
              <PrivateRoute
                path="/clients/:clientId/endrosements"
                exact
                component={EndorsementsPage}
              />
              <PrivateRoute
                path="/clients/:clientId/endrosements/:endorsementId"
                exact
                component={EndorsementDetailsPage}
              />
              <PrivateRoute
                path="/clients/:clientId/requests/:type"
                exact
                component={RequestPage}
              />
            </Switch>
          </section>
          <Footer />
        </div>
      </AlertDispatch.Provider>
    </>
  );
});

export default PrivateLayout;
